import { IMedicalOrder } from '@alberta/konexi-shared';
import { Injectable } from '@angular/core';
import { BaseStateExtension } from '@common/state/state-extension';
import { MedicalOrderModelName } from 'src/app/shared/models/model-names';

export const SERVICES_APPOINTMENTS_TAB_MEDICAL_ORDER_STATE_NAME = 'ServicesAppointmentsTabMedicalOrder';

@Injectable({ providedIn: 'root' })
export class ServiceTabMedicalOrderStateExtension extends BaseStateExtension<IMedicalOrder> {
  public name = MedicalOrderModelName;
  public patientIdToObserve: string | null = null;

  public async canBeStored(item: IMedicalOrder): Promise<boolean> {
    if (!item || item.archived) {
      return false;
    }

    return item.patientId === this.patientIdToObserve;
  }

  protected async afterCreateInternal(item: IMedicalOrder) {
    await this.stateRegistry.createBySync(
      MedicalOrderModelName,
      SERVICES_APPOINTMENTS_TAB_MEDICAL_ORDER_STATE_NAME,
      item
    );
  }

  protected async afterUpdateInternal(item: IMedicalOrder) {
    await this.stateRegistry.updateBySync(MedicalOrderModelName, SERVICES_APPOINTMENTS_TAB_MEDICAL_ORDER_STATE_NAME, [
      item,
    ]);
  }

  protected async removeFromState(item: IMedicalOrder) {
    await this.stateRegistry.removeBySync(MedicalOrderModelName, SERVICES_APPOINTMENTS_TAB_MEDICAL_ORDER_STATE_NAME, [
      item,
    ]);
  }
}
